import { z } from "zod";
import { journeyStepSchema, readJourneyStepSchema } from "./steps.js";
// GET /client/journey/infusion — the Iron infusion tab's own read, separate
// from the home surface: the three things the partner needs before the
// remote appointment, as one card.
export const infusionSurfaceSchema = z.object({
    steps: z.array(journeyStepSchema),
});
export const readInfusionSurfaceSchema = z.object({
    steps: z.array(readJourneyStepSchema),
});
